/**
 * Created by Ning Jiang on 2/7/2019.
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {DungeonQuestFontConfig} from "../config/DungeonQuestFontConfig";
import {DungeonQuestLayerConfig} from "../config/DungeonQuestLayerConfig";
import {DebugInfoOverlay} from "../debug/DebugInfoOverlay";
import {ColorEffectTextureCache} from "../utils/ColorEffectTextureCache";
import {DungeonQuestLogoAreaView} from "./backgrounds/DungeonQuestLogoAreaView";
import {DungeonQuestReelAreaEffectController} from "./backgrounds/DungeonQuestReelAreaEffectController";
import {DungeonQuestSpinController} from "./bigSymbols/DungeonQuestSpinController";
import {DungeonQuestSymbolTransformView} from "./bigSymbols/DungeonQuestSymbolTransformView";
import {DungeonQuest} from "./DungeonQuest";
import {DungeonQuestGameAssets} from "./DungeonQuestGameAssets";
import {DungeonQuestGameConfig} from "./DungeonQuestGameConfig";
import {DungeonQuestSound} from "./DungeonQuestSound";
import {DungeonQuestNormalController} from "./features/DungeonQuestNormalController";
import {DungeonQuestFreeSpinFeatureController} from "./features/freespin/DungeonQuestFreeSpinFeatureController";
import {DungeonQuestScatterAttentionController} from "./features/freespin/DungeonQuestScatterAttentionController";
import {DungeonQuestRandomColossalWildController} from "./features/randomColossalWild/DungeonQuestRandomColossalWildController";
import {DungeonQuestRandomTransformController} from "./features/randomTransform/DungeonQuestRandomTransformController";
import {DungeonQuestGameIntroView} from "./intro/DungeonQuestGameIntroView";
import {DungeonQuestNearWinReelDivider} from "./reel/DungeonQuestNearWinReelDivider";
import {DungeonQuestReelAreaView} from "./reel/DungeonQuestReelAreaView";
import {DungeonQuestReelController} from "./reel/DungeonQuestReelController";
import {DungeonQuestReelView} from "./reel/DungeonQuestReelView";
import {DungeonQuestFreespinZeroBetController} from "./respin/DungeonQuestFreespinZeroBetController";
import {DungeonQuestParsedGameData} from "./server/data/DungeonQuestParsedGameData";
import {DungeonQuestParsedInitData} from "./server/data/DungeonQuestParsedInitData";
import {DungeonQuestServerDataParser} from "./server/DungeonQuestServerDataParser";
import {SoundPlayer} from "./soundplayer/SoundPlayer";
import {DungeonQuestBaseReelSymbol} from "./symbols/DungeonQuestBaseReelSymbol";
import {DungeonQuestReelSymbolStateCreator} from "./symbols/DungeonQuestReelSymbolStateCreator";
import {DungeonQuestBetLines} from "./winPresentations/DungeonQuestBetLines";
import {DungeonQuestBetLineWinIndividualWPController} from "./winPresentations/DungeonQuestBetLineWinIndividualWPController";
import {DungeonQuestBigWinController} from "./winPresentations/DungeonQuestBigWinController";
import {DungeonQuestInitialWPController} from "./winPresentations/DungeonQuestInitialWPController";
import {DungeonQuestNoWinPresentationController} from "./winPresentations/DungeonQuestNoWinPresentationController";
import {DungeonQuestShockWaveController} from "./winPresentations/DungeonQuestShockWaveController";
import {WinCountUpDisplay} from "./winPresentations/WinCountUpDisplay";
import {IndiSymWinHighlightPresentation} from "./winPresentations/IndiSymWinHighlightPresentation";

export class DungeonQuestGameModuleConfig implements IGameModuleConfig {

    public static instance:DungeonQuestGameModuleConfig = new DungeonQuestGameModuleConfig();
    private static background:StillImageBackground;
    private static reelDivider:DungeonQuestNearWinReelDivider;
    private static betLines:DungeonQuestBetLines;

    GAME_CONFIG:IGameConfig = DungeonQuestGameConfig.instance;
    FONTS_CONFIG:IFontsConfig = DungeonQuestFontConfig.getConfig();
    SOUND_CONFIG:ISoundConfig = DungeonQuestSound.instance;
    RESOURCES_CONFIG:IResourcesGroupConfig = DungeonQuestGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new DungeonQuestServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data:any, dataParser:ServerDataParser) => new DungeonQuestParsedInitData(data, <DungeonQuestServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data:any, dataParser:ServerDataParser) => new DungeonQuestParsedGameData(data, <DungeonQuestServerDataParser>dataParser);

    REEL_AREA_VIEW:() => ReelAreaView = () => new DungeonQuestReelAreaView();
    REEL_CONTROLLER:(reelId:number) => ReelController = (reelId:number) => new DungeonQuestReelController(reelId);
    REEL_VIEW:(reelId:number) => PIXI.Container = () => new DungeonQuestReelView();

    REEL_PART_CREATOR?:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig) => {
            return new DungeonQuestBaseReelSymbol(symName, reelId, state);
        }
    );
    SYMBOL_STATE_CREATOR?:() => ReelSymbolStateCreator = () => new DungeonQuestReelSymbolStateCreator();

    INTRO_VIEW:(onClickCallback:() => void) => DungeonQuestGameIntroView =
        (onClickCallback:() => void) => new DungeonQuestGameIntroView({
            layer : GameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            buttonTextStyle : {
                fontFamily : "Open Sans",
                fontStyle : FontStyle.ITALIC,
                fontSize : 34,
                fill : "#ffffff",
                fontWeight : FontWeight.EXTRA_BOLD
            },
            buttonSize : new PIXI.Point(240, 64),
            mobileScale : 1.2,
            portraitScale : 1,
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_MEDIUM]
            },
        });

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new DungeonQuestFreespinZeroBetController(),
        () => new RespinZeroBetController()
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new IndiSymWinHighlightPresentation(indexes)],
        [
            indexes => new DungeonQuestBigWinController(indexes),
            indexes => new DungeonQuestInitialWPController(indexes)
        ],
        [indexes => new DungeonQuestNoWinPresentationController(indexes)]
    ];


    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new DungeonQuestBetLineWinIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    REEL_STOP_PRESENTATIONS?:((index:number) => ReelStopPresentationController)[] = [
        index => new DungeonQuestNormalController(index, "DungeonQuestNormalController"),
        index => new DungeonQuestScatterAttentionController(index, "DungeonQuestScatterAttentionController"),
        index => new DungeonQuestRandomTransformController(index, "DungeonQuestRandomTransformController"),
        index => new DungeonQuestRandomColossalWildController(index, "DungeonQuestRandomColossalWildController"),
        index => new DungeonQuestFreeSpinFeatureController(index, "DungeonQuestFreeSpinFeatureController")
    ];

    SPIN_CONTROLLER:() => SpinController = () => new DungeonQuestSpinController();

    GAME_FEATURE_CREATOR:() => void = () => {
        PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;

        DungeonQuest.background = new StillImageBackground({
            layer : DungeonQuestLayerConfig.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : DungeonQuestGameAssets.MAIN_GAME_LANDSCAPE},
                FREESPIN : {image : DungeonQuestGameAssets.MAIN_GAME_LANDSCAPE}
            },
            stretch : false

        });

        DungeonQuest.soundPlayer = new SoundPlayer();
        DungeonQuest.winCountUpDisplay = new WinCountUpDisplay();
        DungeonQuest.logoAreaView = new DungeonQuestLogoAreaView();
        DungeonQuest.colorEffectTextureCache = new ColorEffectTextureCache();
        DungeonQuest.symbolTransformView = new DungeonQuestSymbolTransformView(ResourcesGroupName.MAIN);
        DungeonQuest.shockWaveController = new DungeonQuestShockWaveController();
        DungeonQuest.reelAreaEffectController = new DungeonQuestReelAreaEffectController();

        DungeonQuestGameModuleConfig.betLines = new DungeonQuestBetLines();
        DungeonQuestGameModuleConfig.reelDivider = DungeonQuestGameModuleConfig.createNearWinDividers();

        if(GameSetting.isDevMode) {
            const debugInfo = new DebugInfoOverlay(DungeonQuestLayerConfig.DEBUG_OVERLAY.name);
        }

        StageManager.legacyScaling = true;
    };

    public static createNearWinDividers():DungeonQuestNearWinReelDivider {
        return new DungeonQuestNearWinReelDivider({
            layer : DungeonQuestLayerConfig.NEAR_WIN_DIV_ATTENTIONS.name,
            texturesGetter : (index:number) => {return [PIXI.Texture.EMPTY]},
            positions : [
                [GameConfig.instance.REEL_AREA_POS_X + 10 + GameConfig.instance.SYMBOL_WIDTH * 0, GameConfig.instance.REEL_AREA_POS_Y - 10],
                [GameConfig.instance.REEL_AREA_POS_X + 10 + GameConfig.instance.SYMBOL_WIDTH * 1, GameConfig.instance.REEL_AREA_POS_Y - 10],
                [GameConfig.instance.REEL_AREA_POS_X + 10 + GameConfig.instance.SYMBOL_WIDTH * 2, GameConfig.instance.REEL_AREA_POS_Y - 10],
                [GameConfig.instance.REEL_AREA_POS_X + 10 + GameConfig.instance.SYMBOL_WIDTH * 3, GameConfig.instance.REEL_AREA_POS_Y - 10],
                [GameConfig.instance.REEL_AREA_POS_X + 10 + GameConfig.instance.SYMBOL_WIDTH * 4, GameConfig.instance.REEL_AREA_POS_Y - 10],
                [GameConfig.instance.REEL_AREA_POS_X + 10 + GameConfig.instance.SYMBOL_WIDTH * 5, GameConfig.instance.REEL_AREA_POS_Y - 10]
            ],
            nearWinLayer : DungeonQuestLayerConfig.REEL_FOREGROUND.name,
            nearWinTexturesGetter : (index:number) => DungeonQuestGameAssets.getNearWinDividerTextures(index),
            reelIndexMap : [
                [0, 1],
                [1, 2],
                [2, 3],
                [3, 4],
                [4, 5]
            ]
        });
    }

    constructor() {
        if(DungeonQuestGameModuleConfig.instance) {
            throw new Error("BlankSlotGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}